import { render, staticRenderFns } from "./cell-action-source-download.vue?vue&type=template&id=026f31ae&scoped=true"
import script from "./cell-action-source-download.ts?vue&type=script&lang=ts&external"
export * from "./cell-action-source-download.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-action-source-download.vue?vue&type=style&index=0&id=026f31ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026f31ae",
  null
  
)

export default component.exports